var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85589 3.07075C4.42478 3.07075 1.63367 5.86186 1.63367 9.29297C1.63367 12.7241 4.42478 15.5152 7.85589 15.5152C11.287 15.5152 14.0781 12.7241 14.0781 9.29297C14.0781 5.86186 11.287 3.07075 7.85589 3.07075ZM7.85589 14.1819C5.16256 14.1819 2.967 11.9863 2.967 9.29297C2.967 6.59964 5.16256 4.40408 7.85589 4.40408C10.5492 4.40408 12.7448 6.59964 12.7448 9.29297C12.7448 11.9863 10.5492 14.1819 7.85589 14.1819ZM4.967 1.95964C4.967 1.59519 5.26922 1.29297 5.63367 1.29297H10.0781C10.4426 1.29297 10.7448 1.59519 10.7448 1.95964C10.7448 2.32408 10.4426 2.6263 10.0781 2.6263H5.63367C5.26922 2.6263 4.967 2.32408 4.967 1.95964ZM8.52256 6.6263V9.29297C8.52256 9.65741 8.22033 9.95964 7.85589 9.95964C7.49144 9.95964 7.18922 9.65741 7.18922 9.29297V6.6263C7.18922 6.26186 7.49144 5.95964 7.85589 5.95964C8.22033 5.95964 8.52256 6.26186 8.52256 6.6263ZM14.3359 5.08852C14.2026 5.22186 14.0337 5.28408 13.8648 5.28408C13.6959 5.28408 13.527 5.22186 13.3937 5.08852L12.0603 3.75519C11.8026 3.49741 11.8026 3.07075 12.0603 2.81297C12.3181 2.55519 12.7448 2.55519 13.0026 2.81297L14.3359 4.1463C14.5937 4.40408 14.5937 4.83075 14.3359 5.08852Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.70deca6fd9256af0d8ee06938d7f23f2.svg";
export { ForwardRef as ReactComponent };